var atc_btn = document.querySelectorAll(".productATC")

atc_btn.forEach(function(btn){

btn.addEventListener("click",function(evt){
evt.preventDefault();
var id = btn.getAttribute("data-id");

var qty = 1;
  var  items = [
    {
      'id':id,
      'quantity':qty
    }
  ];
   var formData = {
      items: items
    }
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
//        console.log(response)
        return response.json();
      })
      .then(data => {
//        console.log(data.items[0])
        
        itemAdd(data.items[0])
      
      })
      .catch((error) => {
        console.error('Error:', error);
      }); 


})
})

function itemAdd(product) {
  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
    detail: {
      product: product
    }
  }))
}